import Router from 'next/router';
import { proxy, useSnapshot } from 'valtio';
import type { ReleaseTypeUpload } from '@components/Dashboard/Upload/helpers';
import type { ContractType } from '@graphql/reactQuery';
import { DASHBOARD_PATHNAMES, UPLOAD_PATHNAMES } from './helpers';

export type LeftNavStateType = {
  isLikedSoundsPage: boolean;
  uploadStepsData: {
    draftId: string;
    releaseType: ReleaseTypeUpload;
    currentStepId: number;
    numSteps: number;
    numStepsComplete: number;
  } | null;
  editStepsData: {
    releaseId: string;
    contractType: ContractType;
    currentStepId: number;
  } | null;
  previousPath: string;
};

const initialLeftNavState: LeftNavStateType = {
  isLikedSoundsPage: false,
  uploadStepsData: null,
  editStepsData: null,
  previousPath: '/',
};

export const LeftNavState = proxy<LeftNavStateType>(initialLeftNavState);

export const useLeftNavState = () => useSnapshot(LeftNavState);

if (typeof window !== 'undefined') {
  // save the previous path when going to different pages so we can go back from dashboard pages
  Router.events.on('routeChangeComplete', () => {
    const pathname = Router.pathname;
    if (!DASHBOARD_PATHNAMES.includes(pathname) && !UPLOAD_PATHNAMES.includes(pathname)) {
      LeftNavState.previousPath = Router.asPath;
    }
  });
}
